import { computed, effect, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../../modules/shared/store/common/component-store-v2.factory';
import { FilterBuilder } from '@libs/shared/utils/grid.builder';
import { routeParams } from '../../../../../modules/shared/shared.global-service';
import {
    getEmploymentsFrag,
    getUserGroupsFrag,
    organizationWithChildrenFrag,
} from './user-role-medical-service.query';
import { GroupUserObject } from '@libs/types/src/user/object-type/group-user.object';
import { EmploymentGridItemObject } from '@libs/types/src/user/object-type/employment-grid.object';
import { OrganizationGridItemObject } from '@it2go/types';

@Injectable()
export class UserRoleMedicalServiceStore extends ComponentStoreV2Factory {

    public userGroups = computed<GroupUserObject[]>(() => this.data.getGroupUsers()?.['items'] || []);
    public childOrganizations = computed<OrganizationGridItemObject[]>(() =>
        this.data.getOrganizations()?.items?.[0]?.childOrganizations ?? [],
    );
    public employedIn = computed<number[]>(() => {
        return (this.data.getEmployments()?.['items'] || []).map((it: EmploymentGridItemObject) => it.serviceId);
    });
    public employmentUpdated = false;

    constructor() {
        super();

        this.onSuccess(
            () => this.refresh(),
            'createEmployment',
            'updateEmployment',
            'deleteEmployment',
        );
        this.onSuccess(
            () => this.employmentUpdated = true,
            'updateEmployment',
            'deleteEmployment',
        );
        effect(() => {
            this.refresh();
        });
    }

    public refresh(): void {
        this.api.getGroupUsers(FilterBuilder.singlePage({
            userId: routeParams.id(),
            organizationId: this.globalGlobalStore.organizationStore.selectedId(),
        }), getUserGroupsFrag).then();
        this.api.getEmployments(FilterBuilder.singlePage({
            userId: routeParams.id(),
        }), getEmploymentsFrag).then();
        this.api.getOrganizations(
            FilterBuilder.singleItem({
                id: this.globalGlobalStore.organizationStore.selectedId(),
            }),
            organizationWithChildrenFrag,
        ).then();
    }

}
